<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'CUSTOMIZE_PARTNER.PAGE_TITLE' | translate }}
    </glxy-page-title>
  </glxy-page-toolbar>
  <mat-accordion multi="true">
    <ng-container *ngIf="brandingAndApps$ | async as branding">
      <mat-expansion-panel class="colors">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'CUSTOMIZE_PARTNER.COLOR.HEADING' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-brand-color [primaryColor]="branding?.primaryColor" [uiTheme]="branding?.uiTheme"></app-brand-color>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'CUSTOMIZE_PARTNER.FILE_UPLOADS.LOGO.HEADING' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-customize-image-upload
          [currentImageUrl]="branding?.logoUrl"
          [partnerId]="partnerId$ | async"
          category="logo"
        >
          <h2>{{ 'CUSTOMIZE_PARTNER.FILE_UPLOADS.LOGO.TITLE' | translate }}</h2>
          <p>
            {{ 'CUSTOMIZE_PARTNER.FILE_UPLOADS.LOGO.DESCRIPTION' | translate }}
          </p>
        </app-customize-image-upload>
        <p class="small">
          {{ 'CUSTOMIZE_PARTNER.FILE_UPLOADS.LOGO.CACHE' | translate }}
        </p>
        <div *ngIf="showUpgradeCTA$ | async" class="upgrade-cta">
          <mat-icon class="upgrade-cta-icon">trending_up</mat-icon>
          <p class="upgrade-text-cta">{{ 'CUSTOMIZE_BRANDING.LOGO.ALERT' | translate }} &nbsp;</p>
          <a class="upgrade-link-cta" [routerLink]="'/upgrade-subscription-tier'">
            {{ 'COMMON.ACTION_LABELS.UPGRADE' | translate }}
          </a>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'CUSTOMIZE_PARTNER.FILE_UPLOADS.FAVICON.HEADING' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-customize-image-upload
          [currentImageUrl]="branding?.faviconUrl"
          [partnerId]="partnerId$ | async"
          category="favicon"
        >
          <h2>
            {{ 'CUSTOMIZE_PARTNER.FILE_UPLOADS.FAVICON.TITLE' | translate }}
          </h2>
          <p>
            {{ 'CUSTOMIZE_PARTNER.FILE_UPLOADS.FAVICON.DESCRIPTION' | translate }}
          </p>
          <p>
            {{ 'CUSTOMIZE_PARTNER.FILE_UPLOADS.FAVICON.REQUIREMENTS' | translate }}
          </p>
        </app-customize-image-upload>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'CUSTOMIZE_PARTNER.FILE_UPLOADS.SHORTCUT_ICON.HEADING' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-customize-image-upload
          [currentImageUrl]="branding?.shortcutIconUrl"
          [partnerId]="partnerId$ | async"
          category="mobile_shortcut_icon"
        >
          <h2>
            {{ 'CUSTOMIZE_PARTNER.FILE_UPLOADS.SHORTCUT_ICON.TITLE' | translate }}
          </h2>
          <p>
            {{ 'CUSTOMIZE_PARTNER.FILE_UPLOADS.SHORTCUT_ICON.DESCRIPTION' | translate }}
          </p>
          <p>
            {{ 'CUSTOMIZE_PARTNER.FILE_UPLOADS.SHORTCUT_ICON.REQUIREMENTS' | translate }}
          </p>
        </app-customize-image-upload>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'CUSTOMIZE_PARTNER.PRODUCT_NAMES.HEADING' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-product-names [appNames]="branding?.apps"></app-product-names>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'CUSTOMIZE_PARTNER.PRODUCT_SETTINGS.HEADING' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-product-settings></app-product-settings>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'CUSTOMIZE_PARTNER.EXIT_LINK.HEADING' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-exit-link></app-exit-link>
      </mat-expansion-panel>
    </ng-container>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'CUSTOMIZE_PARTNER.OTHER_HEADINGS.BA_SETTINGS' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <h3 class="vform-heading">
        {{ 'CUSTOMIZE_PARTNER.EXECUTIVE_REPORT_PAGE_LAYOUT' | translate }}
      </h3>
      <a [routerLink]="['/customize-design/customize-executive-report/']">
        <mat-icon inline>edit</mat-icon>
        {{ 'CUSTOMIZE_PARTNER.EDIT_DEFAULT_EXEC_REPORT_TEMPLATE' | translate }}
      </a>
      <v-form [formOptions]="bcsFormOptions"></v-form>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'CUSTOMIZE_PARTNER.OTHER_HEADINGS.GENERAL_SETTINGS' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <v-form [formOptions]="gpsFormOptions"></v-form>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'CUSTOMIZE_PARTNER.OTHER_HEADINGS.LISTING_SOURCES' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-listing-sources></app-listing-sources>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'CUSTOMIZE_PARTNER.OTHER_HEADINGS.SALES' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-sales-snapshot-settings></app-sales-snapshot-settings>
      <v-form [formOptions]="salesFormOptions"></v-form>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'CUSTOMIZE_PARTNER.OTHER_HEADINGS.EMAIL_SETTINGS' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <v-form [formOptions]="esFormOptions"></v-form>
    </mat-expansion-panel>
  </mat-accordion>
</glxy-page>
